module.exports = __webpack_public_path__ + "img/iphone.d934845c.svg";